export default function Applications() {
  const applications = [
    {
      title: 'Производственные цеха',
      description: 'Перемещение заготовок, деталей и готовой продукции в машиностроении, металлообработке'
    },
    {
      title: 'Склады и логистика',
      description: 'Погрузочно-разгрузочные работы, складирование грузов'
    },
    {
      title: 'Строительство',
      description: 'Подъём строительных материалов, конструкций, оборудования'
    },
    {
      title: 'Ремонтные мастерские',
      description: 'Обслуживание техники, подъём двигателей, узлов и агрегатов'
    }
  ];

  return (
    <section id="applications" className="py-12 sm:py-16 lg:py-20 bg-gray-50">
      <div className="max-w-[1280px] mx-auto px-4 sm:px-6 lg:px-10">
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-8 sm:mb-10 lg:mb-12">Области применения</h2>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
          {applications.map((item, index) => (
            <div key={index} className="bg-white p-6 sm:p-8 border border-gray-200">
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-3">{item.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}